import { render, staticRenderFns } from "./BaseSubmit.vue?vue&type=template&id=7c81ceee&lang=pug&"
import script from "./BaseSubmit.vue?vue&type=script&lang=js&"
export * from "./BaseSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports